@if (fleets) {
	<app-sticky-header>
		<div class="container">
			<div class="row">
				<div class="col-sm-5 overview">
					<div class="section-title">My {{brand.fleetPlural}} Overview</div>
					<div><b>Number of {{brand.fleetPlural}}:</b> <span class="focal">{{fleets.length}}</span></div>
					<div><b>Number of {{brand.assetPlural}}:</b> <span class="focal">{{getAssetCount()}}</span></div>
				</div>
				<div class="col-sm-7 global-search mt-xs">
					<div class="search-title">Search all {{brand.fleetPlural | lowercase}} / {{brand.assetPlural | lowercase}}</div>
					<ng-template #searchResult let-r="result" let-t="term">
						<ngb-highlight
							result="{{r.category}}: {{r.name}} {{r.serial ? '(SN: ' + r.serial + ')' : ''}} {{r.obcu && r.obcu.toLowerCase().indexOf(t.toLowerCase()) > -1 ? '(OBCU: ' + r.obcu + ')' : ''}}"
							[term]="t"></ngb-highlight>
					</ng-template>
					<input [ngModel]="searchText" (ngModelChange)="searchText = $event" [ngbTypeahead]="searchFunc" container="body" [editable]="false" [ngb-highlight]="searchText"
						[resultTemplate]="searchResult" (selectItem)="searchNav($event.item)" placeholder="Search" type="text" class="form-control">
				</div>
			</div>
		</div>
	</app-sticky-header>
}
<div class="container">
	@if (!api.user?.support) {
		<div>
			<div class="row">
				@for (fleet of fleets; track fleet) {
					<div class="col-lg-6">
						<app-fleet-summary [fleet]="fleet"></app-fleet-summary>
					</div>
				}
			</div>
			@if (fleets && fleets.length === 0) {
				<div class="no-fleets">You have no {{brand.fleetPlural | lowercase}} to view</div>
			}
		</div>
	}
	@if (api.user?.support) {
		<div>
			<div class="row">
				@for (org of orgs; track org) {
					@for (fleet of org.fleets; track fleet) {
						<div class="col-lg-6 py-3">
							<app-fleet-summary [routerLink]="['fleet', fleet.fleet_id]" [fleet]="fleet" [organization]="org" class="clickable"></app-fleet-summary>
						</div>
					}
				}
			</div>
		</div>
	}
	@if (fleets === undefined) {
		<div class="loading-status">
			<div class="logo-spin"></div>
			Loading fleets...
		</div>
	}
</div>